module.exports = __webpack_public_path__ + "img/全景智联中台服务流程控制与管理服务系统.6c2d7a2d.jpg";